// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 278) return "static/chunks/278-3b060a7efb1d481c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"668":"340c23d0c8ba45a0","937":"08757bb9cf5e9559"}[chunkId] + ".js";
};